<div
  class="upload-dropzone"
  [class.drag-over]="isDragOver()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  (click)="fileInput.click()"
>
  <div class="upload-icon-container">
    <img
      src="assets/images/upload-icon.svg"
      alt="Upload"
      class="upload-icon"
      width="24"
      height="24"
    />
  </div>
  <div class="upload-text">
    <p class="upload-title">
      {{ title }} <span class="browse-link">{{ browseLinkText }}</span>
    </p>
    <p class="upload-subtitle">{{ subtitle }}</p>
  </div>
  <input
    #fileInput
    type="file"
    [attr.accept]="accept"
    (change)="onBrowseFileSelected($event)"
    style="display: none"
  />
</div>
